import { useContext } from 'react';

import Card3D from '@/components/game/3d/object/card/Card3D';
import { stepStackedCardY } from '@/const/magicNumber';
import { ViewContext } from '@/state/contexts';
import { getCardTexturePath } from '@/util/card';

const CompletedContractsAndAwardsBuilder = ({
	playerId,
	completedContractsAndAwards,
}) => {
	const { setShowCardTableModal, setCardsOnTablePlayerId }: any =
		useContext(ViewContext); // numPlayers, monthTracker, seasonTracker, carbonReservoir, cardsOnTablePlayerId, showCardTableModal,

	function displayCardsOnTableForPlayerId() {
		setCardsOnTablePlayerId(playerId);
		setShowCardTableModal(true);
	}

	if (
		completedContractsAndAwards == null ||
		completedContractsAndAwards.length === 0
	) {
		return;
	}

	const ccaArray: any = [];

	for (let z = completedContractsAndAwards.length - 1; z >= 0; z--) {
		const texturePath = getCardTexturePath(completedContractsAndAwards[z]);

		ccaArray.push(
			<group
				key={`aca_group__${z}`}
				position={[4, 0.6 + stepStackedCardY * (z / 2), 5.25 + 1.5 * z]}
			>
				<Card3D
					key={`aca__${z}`}
					texturePath={texturePath}
					cardArr={completedContractsAndAwards}
					viewCardModal={displayCardsOnTableForPlayerId}
				/>
			</group>
		);
	}

	return <>{ccaArray}</>;
};

export default CompletedContractsAndAwardsBuilder;
